import React from "react";
import { Descriptions } from "antd";
import Separator from "components/Separator/Separator";
const SummaryLabel = (props) => {
   var sum;
   var arr = [];

   if (props.columnProperties) {
      props.columnProperties.forEach((column) => {
         sum = 0;
         props.dataSource.forEach((data) => {
            sum += +data[column.label ? column.label.toLowerCase() : column.label];
         });
         arr.push({
            sum: sum,
            label: column.label,
            orderKey: column.orderKey,
            addition: column.addition,
            serie: column.serie
         });
      });
   }

   return (
      <div className="gx-m-0">
         {arr
            ? arr.map((value) => {
                 if (value.serie === undefined) value.serie = props.selectedSerie;
                 if (value.addition === true && props.selectedSerie === value.serie) {
                    return (
                          <Descriptions bordered size="middle" className="gx-mr-1 gx-mb-2">
                             <Descriptions.Item label={value.label} className="gx-text-primary">
                                {Separator(value.sum.toFixed(2))}
                             </Descriptions.Item>
                          </Descriptions>
                    );
                 }
                 return null;
              })
            : ""}
      </div>
   );
};
export default SummaryLabel;
